import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  ModelSignal,
  OnInit,
  OutputEmitterRef,
  Signal,
  computed,
  input,
  model,
  output,
} from '@angular/core';
import { LetDirective } from '@ngrx/component';

import { FilterClearButtonComponent, FilterDateSelectorComponent, FilterGroupComponent } from '@core/ui';
import { FacetExpansionStateService } from '@mp/shared/facets/util';

import { DateRange } from '../../models';

import { SelectedDateRangePipe } from './selected-date-range.pipe';

const expandedSelection = 'expanded';

@Component({
  selector: 'mp-date-range-facet',
  templateUrl: './date-range-facet.component.html',
  styleUrl: './date-range-facet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DatePipe,
    LetDirective,

    FilterDateSelectorComponent,
    SelectedDateRangePipe,
    FilterGroupComponent,
    FilterClearButtonComponent,
  ],
  providers: [FacetExpansionStateService],
})
export class DateRangeFacetComponent implements OnInit {
  readonly filterName: InputSignal<string> = input.required<string>();

  readonly icon: InputSignal<string | undefined> = input<string | undefined>();

  readonly dateFrom: ModelSignal<string | undefined> = model<string | undefined>();

  readonly dateTo: ModelSignal<string | undefined> = model<string | undefined>();

  readonly showDateTo: InputSignal<boolean> = input<boolean>(true);

  readonly selectionKey: InputSignal<string> = input<string>('');

  readonly dateRangeChange: OutputEmitterRef<DateRange> = output<DateRange>();

  protected readonly dateFromSelectorLabel: Signal<string> = computed(() => this.getDateFromSelectorLabel());

  get isExpanded(): boolean {
    return this.facetExpansionStateService.isExpanded(expandedSelection);
  }

  constructor(private readonly facetExpansionStateService: FacetExpansionStateService) {}

  ngOnInit(): void {
    this.facetExpansionStateService.setSelectionKey(this.selectionKey());
  }

  onExpandedChange(expanded: boolean): void {
    this.facetExpansionStateService.setExpanded(expanded);
  }

  clearDateRangeSelection(): void {
    this.dateFrom.set(undefined);
    this.dateTo.set(undefined);
    this.emitDateRangeChange();
  }

  emitDateRangeChange(): void {
    this.dateRangeChange.emit({ dateFrom: this.dateFrom(), dateTo: this.dateTo() });
  }

  private getDateFromSelectorLabel(): string {
    if (!this.showDateTo()) return 'ab';
    return this.dateTo() || !this.dateFrom() ? 'von' : 'ab';
  }
}
